import { TextField } from '@mui/material';
import { useCampaignCreation } from 'pages/AdCampaignPage/CampaignCreationContext';
import * as S from './styles';

export interface CustomBudgetProps {}

const CustomBudget: React.FC<CustomBudgetProps> = () => {
  const {
    state: {
      minCustomBudget,
      isValidCustomBudget,
      values: { campaignBudgetMilliCent },
    },
    dispatch,
  } = useCampaignCreation();

  return (
    <S.BudgetContainer>
      <TextField
        fullWidth
        label={`$${minCustomBudget}+`}
        value={campaignBudgetMilliCent || ''}
        onChange={(e) =>
          dispatch({
            type: 'CHANGE_VALUES',
            payload: {
              campaignBudgetMilliCent: Number(e.target.value),
            },
          })
        }
      />

      {Boolean(campaignBudgetMilliCent) && !isValidCustomBudget && (
        <S.ErrorText>
          Custom budget amount must be greater than ${minCustomBudget - 1}
        </S.ErrorText>
      )}
    </S.BudgetContainer>
  );
};

export default CustomBudget;
